// Add training-session photos to public/training-gallery, then add one entry
// here for each photo. Keeping the list in one file makes the gallery easy to
// update without changing the Gallery component.
//
// Example:
// {
//   src: 'school-name-session.jpg',
//   alt: 'Students taking part in an abacus training session',
//   title: 'Abacus Training Session',
//   location: 'School name, Bengaluru',
// },

const trainingPhotos = [
  {
    src: 'teacher-training-01.jpeg',
    alt: 'Interactive teacher-training workshop led by The Bright Future',
    title: 'Interactive Teacher Training',
    location: 'Professional development workshop',
  },
  {
    src: 'teacher-training-02.jpeg',
    alt: 'Teachers and facilitators gathered after a Bright Future training programme',
    title: 'Teacher Training Programme',
    location: 'Educators and facilitators',
  },
  {
    src: 'school-session-05.jpeg',
    alt: 'Teacher with students gathered together during a school session',
    title: 'Learning Together',
    location: 'School visit · 3 September 2026',
  },
  {
    src: 'school-session-01.jpeg',
    alt: 'Teacher smiling with young students dressed in colourful traditional clothing',
    title: 'Joyful Moments with Students',
    location: 'Classroom interaction',
  },
  {
    src: 'school-session-02.jpeg',
    alt: 'Teacher seated with a group of young students in their classroom',
    title: 'A Memorable School Visit',
    location: 'Student engagement session',
  },
  {
    src: 'school-session-03.jpeg',
    alt: 'Teacher and students smiling together for a classroom photograph',
    title: 'Smiles from the Classroom',
    location: 'School visit · 3 September 2026',
  },
  {
    src: 'school-session-04.jpeg',
    alt: 'Teacher surrounded by students in traditional clothing after a class activity',
    title: 'Celebrating Learning',
    location: 'Classroom interaction',
  },
  {
    src: 'school-session-08.jpeg',
    alt: 'Teacher with a large group of students inside a classroom',
    title: 'Students and Teacher Together',
    location: 'School training session',
  },
  {
    src: 'school-session-06.jpeg',
    alt: 'Teacher seated with students smiling during a school visit',
    title: 'Building Happy Connections',
    location: 'Student engagement session',
  },
  {
    src: 'school-session-07.jpeg',
    alt: 'Teacher and students posing together during a classroom activity',
    title: 'A Special Classroom Moment',
    location: 'School visit · 3 September 2026',
  },
  {
    src: 'school-session-09.jpeg',
    alt: 'Group of students gathered around their teacher during a classroom session',
    title: 'Growing Through Learning',
    location: 'School training session',
  },
  {
    src: 'school-session-11.jpeg',
    alt: 'Teacher and students standing together at the end of a school session',
    title: 'Together in the Classroom',
    location: 'Student engagement session',
  },
  {
    src: 'school-session-10.jpeg',
    alt: 'Teacher and a large group of children during a classroom visit',
    title: 'School Visit Group Session',
    location: 'School visit · 3 September 2026',
  },
];

export default trainingPhotos;
